import axios from '../../api/axios';
import { getUserById } from './users';
import {
	syncStudentNotesStart,
	syncStudentNotesSuccess,
	syncStudentNotesFailure,
	studentNoteMutationStart,
	studentNoteMutationSuccess,
	studentNoteMutationFailure,
	fetchMentionableStaffStart,
	fetchMentionableStaffSuccess,
	fetchMentionableStaffFailure,
} from '../reducers/studentNotes';

const errMessage = (error) =>
	error?.response?.data?.message || error?.message || 'Ocurrió un error';

/**
 * Sincroniza las notas del estudiante recargando el perfil (`userSelected` vía getUserById).
 */
export const syncStudentNotes = (userId) => async (dispatch) => {
	if (!userId) {
		dispatch(syncStudentNotesFailure('Usuario no válido'));
		return null;
	}
	dispatch(syncStudentNotesStart());
	try {
		const data = await dispatch(getUserById(userId));
		if (data?.user) {
			dispatch(syncStudentNotesSuccess());
			return data;
		}
		dispatch(syncStudentNotesFailure('No se pudo cargar el usuario'));
		return null;
	} catch (error) {
		dispatch(syncStudentNotesFailure(errMessage(error)));
		return null;
	}
};

export const createStudentNote =
	({ userId, actorId, title, content, category, status, taggedUsers }) =>
	async (dispatch) => {
		dispatch(studentNoteMutationStart());
		try {
			const response = await axios.post(
				`/users/${userId}/student-notes`,
				{ title, content, category, status, actorId, taggedUsers },
				{ withCredentials: true }
			);
			if (response.status === 201) {
				await dispatch(getUserById(userId));
				dispatch(studentNoteMutationSuccess());
				return { ok: true, message: response.data?.message };
			}
			dispatch(studentNoteMutationFailure('Respuesta inesperada'));
			return { ok: false };
		} catch (error) {
			dispatch(studentNoteMutationFailure(errMessage(error)));
			return { ok: false, message: errMessage(error) };
		}
	};

export const updateStudentNote =
	({ userId, noteId, actorId, title, content, category, status, taggedUsers }) =>
	async (dispatch) => {
		dispatch(studentNoteMutationStart());
		try {
			const response = await axios.put(
				`/users/${userId}/student-notes/${noteId}`,
				{ title, content, category, status, actorId, taggedUsers },
				{ withCredentials: true }
			);
			if (response.status === 200) {
				await dispatch(getUserById(userId));
				dispatch(studentNoteMutationSuccess());
				return { ok: true, message: response.data?.message };
			}
			dispatch(studentNoteMutationFailure('Respuesta inesperada'));
			return { ok: false };
		} catch (error) {
			dispatch(studentNoteMutationFailure(errMessage(error)));
			return { ok: false, message: errMessage(error) };
		}
	};

export const deleteStudentNote =
	({ userId, noteId, actorId }) =>
	async (dispatch) => {
		dispatch(studentNoteMutationStart());
		try {
			const response = await axios.delete(`/users/${userId}/student-notes/${noteId}`, {
				data: { actorId },
				withCredentials: true,
			});
			if (response.status === 200) {
				await dispatch(getUserById(userId));
				dispatch(studentNoteMutationSuccess());
				return { ok: true, message: response.data?.message };
			}
			dispatch(studentNoteMutationFailure('Respuesta inesperada'));
			return { ok: false };
		} catch (error) {
			dispatch(studentNoteMutationFailure(errMessage(error)));
			return { ok: false, message: errMessage(error) };
		}
	};

/**
 * Carga el personal "mencionable" (no estudiantes ni profesores) desde `/users/getAllUsers`.
 * Se filtra del lado servidor por paginación grande; el filtro real por `typeUser` se aplica en el editor.
 */
export const fetchMentionableStaff =
	({ pageSize = 500 } = {}) =>
	async (dispatch) => {
		dispatch(fetchMentionableStaffStart());
		try {
			const response = await axios.get(
				`/users/getAllUsers?page=0&pageSize=${pageSize}&search=`,
				{ withCredentials: true }
			);
			if (response.status === 200) {
				const rows = Array.isArray(response.data?.data) ? response.data.data : [];
				dispatch(fetchMentionableStaffSuccess(rows));
				return { ok: true, data: rows };
			}
			dispatch(fetchMentionableStaffFailure('Respuesta inesperada'));
			return { ok: false };
		} catch (error) {
			dispatch(fetchMentionableStaffFailure(errMessage(error)));
			return { ok: false, message: errMessage(error) };
		}
	};

export const addStudentNoteReply =
	({ userId, noteId, actorId, content, title, category, status, taggedUsers }) =>
	async (dispatch) => {
		dispatch(studentNoteMutationStart());
		try {
			const body = { content, actorId };
			if (title?.trim()) body.title = title.trim();
			if (category) body.category = category;
			if (status) body.status = status;
			if (Array.isArray(taggedUsers)) body.taggedUsers = taggedUsers;

			const response = await axios.post(
				`/users/${userId}/student-notes/${noteId}/replies`,
				body,
				{ withCredentials: true }
			);
			if (response.status === 201) {
				await dispatch(getUserById(userId));
				dispatch(studentNoteMutationSuccess());
				return { ok: true, message: response.data?.message };
			}
			dispatch(studentNoteMutationFailure('Respuesta inesperada'));
			return { ok: false };
		} catch (error) {
			dispatch(studentNoteMutationFailure(errMessage(error)));
			return { ok: false, message: errMessage(error) };
		}
	};
